import styled from 'styled-components';
import { LabeledRatingStarsMixin } from '../../mixins/components/LabeledRatingStarsMixin';
export var StyledLabeledRatingStars = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledLabeledRatingStars",
  componentId: "c11n-8-111-1__sc-13tpwil-0"
})(["", ""], LabeledRatingStarsMixin);